<template>
  <v-checkbox
    v-model="value"
    :label="label"
    :disabled="disabled"
    :class="{ squareSelected, 'no-ellipsis': noEllipsis, rounded }"
    hide-details="auto"
    class="e-checkbox"
  >
    <template v-if="slots.label" #label>
      <slot name="label" />
    </template>
  </v-checkbox>
</template>

<script setup lang="ts">
defineProps<{
  label?: string;
  disabled?: boolean;
  squareSelected?: boolean;
  noEllipsis?: boolean;
  rounded?: boolean;
}>();

const slots = defineSlots<{
  label?: () => JSX.Element;
}>();

const value = defineModel<boolean>({ required: true });
</script>

<style scoped lang="scss">
.e-checkbox {
  &.squareSelected {
    :deep(.v-selection-control:not(.v-selection-control--dirty)) {
      .v-selection-control__input {
        color: $primary-color;

        &:after {
          content: '';

          width: 12px;
          height: 12px;

          background-color: $primary-color;
          border-radius: 3px;

          opacity: 0.5;

          pointer-events: none;
        }
      }
    }

    &.v-input--disabled {
      :deep(.v-selection-control:not(.v-selection-control--dirty)) {
        .v-selection-control__input {
          color: $text-inactive-color !important;

          &:after {
            background-color: $text-inactive-color;
          }
        }
      }
    }
  }

  &.no-ellipsis {
    :deep(.v-selection-control .v-label) {
      white-space: normal;
    }
  }

  &.rounded {
    :deep(.v-selection-control .v-selection-control__input) {
      border-radius: 50%;
    }
  }
}
</style>
